import gql from 'graphql-tag';

export const CREATE_REGION = gql`
  mutation createRegion($input: CreateRegionInput!) {
    createRegion(input: $input) {
      value
    }
  }
`;

export const UPSERT_QUANTITIY_UNIT = gql`
  mutation upsertQuantityUnits($input: [UpsertQuantityUnitInput!]!) {
    upsertQuantityUnits(input: $input) {
      value
      shorthand
      code
    }
  }
`;

export const UPSERT_LOGISTIC_MATERIAL = gql`
  mutation upsertLogisticMaterials($input: [UpsertLogisticMaterialInput!]!) {
    upsertLogisticMaterials(input: $input) {
      value
    }
  }
`;

export const CREATE_COUNTRIES = gql`
  mutation createCountries($input: [CreateCountryInput!]!) {
    createCountries(input: $input) {
      value
      currency
      code
    }
  }
`;

export const CREATE_PORT_OF_LOADING = gql`
  mutation createPortOfLoading($input: CreatePortOfLoadingInput!) {
    createPortOfLoading(input: $input) {
      value
      country
      erpId
      id
      trackingCode
    }
  }
`;

export const CREATE_PORT_OF_DESTINATION = gql`
mutation createPortOfDestination($input: CreatePortOfDestinationInput!) {
  createPortOfDestination(input: $input) {
    value
    country
    erpId
    id
    trackingCode
  }
}
`;

export const CREATE_INCOTERMS = gql`
mutation createPortOfDestination($input: CreatePortOfDestinationInput!) {
  createPortOfDestination(input: $input) {
    value
    country
    erpId
    id
    trackingCode
  }
}
`;

export const CREATE_PRICE_INDEXES = gql`
mutation createPriceIndex($input: CreatePriceIndexInput!) {
  createPriceIndex(input: $input) {
   id
   value
   index
   period 
  }
}
`;

export const CREATE_OTHER_PRODUCT = gql`
mutation createOtherProduct($input: CreateOtherProductInput!) {
  createOtherProduct(input: $input) {
    id
    code
    group
    defaultVolume
    name
    officialName
    tag
    groupTag
    taxRate
    erpId
    isDeleted
    isReverseCharge
  }
}
`;